const initialState = () => ({
  newVersionAvailable: false,
});

const state = initialState();

const mutations = {
  RESET: (state) => {
    const emptyState = initialState();
    Object.keys(emptyState).forEach((k) => {
      state[k] = emptyState[k];
    });
  },
  NEW_VERSION_AVAILABLE: (state, { version }) => {
    state.newVersionAvailable = version;
  },
};

const actions = {
  reset({ commit }) {
    commit("RESET");
  },
  newVersionAvailable({ commit }, version) {
    commit("NEW_VERSION_AVAILABLE", version);
  },
};

const getters = {
  isNewVersionAvailable(state) {
    return !!state.newVersionAvailable;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
